import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { ServicesSection } from './components/ServicesSection';
import { SuccessStoriesSection } from './components/SuccessStoriesSection';
import { FoundersSection } from './components/FoundersSection';
import { NetworkSection } from './components/NetworkSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { RobFridPage } from './pages/RobFridPage';
const HomePage = () => <main data-id="element-0" data-mp="31cjp83nwlt2y">
    <HeroSection data-id="element-1" data-mp="2wk0av4he6tx3" />
    <MissionSection data-id="element-2" data-mp="2wjgq7g0cxrfd" />
    <ServicesSection data-id="element-3" data-mp="2wj8cxn0bok3n" />
    <SuccessStoriesSection data-id="element-4" data-mp="2wip7v6vrtq71" />
    <FoundersSection data-id="element-5" data-mp="28ufo0ai4bcij" />
    <NetworkSection data-id="element-6" data-mp="28tw9l3rof699" />
    <ContactSection data-id="element-7" data-mp="28t4mkhc5agul" />
  </main>;
export function App() {
  return <BrowserRouter data-id="element-8" data-mp="23vuokdaowwv5">
      <div className="min-h-screen bg-navy-900 text-white selection:bg-ice-500 selection:text-navy-900" data-id="element-9" data-mp="23u9ueosaffxt">
        <Navbar data-id="element-10" data-mp="3ij652c0mxp8x" />
        <Routes data-id="element-11" data-mp="3ijftvw9y1qd1">
          <Route path="/" element={<HomePage data-id="element-13" data-mp="3mlavz2zp87rv" />} data-id="element-12" data-mp="3ihuyk4ft23e4" />
          <Route path="/rob-frid" element={<RobFridPage data-id="element-15" data-mp="3mjq2lgp4euvl" />} data-id="element-14" data-mp="3mkhlps1j704z" />
        </Routes>
        <Footer data-id="element-16" data-mp="3rcj2nr9n9f1c" />
      </div>
    </BrowserRouter>;
}